import { isNil, orderBy, size } from 'lodash';
import { useMemo } from 'react';

import * as changelog from 'main/changelog';

export default function useChangelogData(id: string) {
    const summaries = useMemo(() => orderBy(changelog.summaries, ({ date }) => new Date(date).getTime(), 'asc'), []);
    const index = useMemo(() => summaries.findIndex((item) => item.id === id), [id, summaries]);

    const summary = summaries.at(index);
    const full = useMemo(() => changelog.fulls.find((item) => item.id === id), [id]);

    if (isNil(summary) || isNil(full)) {
        return null;
    }

    return {
        summaries,
        summary: {
            previous: index > 0 ? summaries[index - 1] : null,
            current: summary,
            next: index < size(summaries) - 1 ? summaries[index + 1] : null
        },
        full
    };
}
